import { render, staticRenderFns } from "./ResizableWidth.vue?vue&type=template&id=52726cdd&scoped=true&"
import script from "./ResizableWidth.vue?vue&type=script&lang=js&"
export * from "./ResizableWidth.vue?vue&type=script&lang=js&"
import style0 from "./ResizableWidth.vue?vue&type=style&index=0&id=52726cdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52726cdd",
  null
  
)

export default component.exports